import {RootState} from 'redux/rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const dashboardStatus = createSelector(
  [(state: RootState) => state.dashboard.isLoading],
  isLoading => isLoading,
);

export const dashboardSuccess = createSelector(
  [(state: RootState) => state.dashboard.successDashboard],
  successDashboard => successDashboard,
);

export const dashboardFailure = createSelector(
  [(state: RootState) => state.dashboard.errorDashboard],
  errorDashboard => errorDashboard,
);

export const dashboardSearchSuggestions = createSelector(
  [(state: RootState) => state.dashboard.searchSuggestions],
  searchSuggestions => searchSuggestions,
);

export const dashboardSearchTotalPage = createSelector(
  [(state: RootState) => state.dashboard.totalPages],
  totalPages => totalPages,
);

export const dashboardSearchNextPage = createSelector(
  [(state: RootState) => state.dashboard.nextPage],
  nextPage => nextPage,
);

export const dashboardSearchCurrentPage = createSelector(
  [(state: RootState) => state.dashboard.currentPage],
  currentPage => currentPage,
);
